import { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ArrowLeft, ArrowLeftSquare, ArrowLeftSquareFill } from 'react-bootstrap-icons';

let zIndexCounter = 5000;

const DocumentViewer = ({ url, close, initialWidth = 650, initialHeight = 450, title, icon }) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [size, setSize] = useState({ width: initialWidth, height: initialHeight });
    const [zIndex, setZIndex] = useState(zIndexCounter);
    const history = useHistory();

    const [dragging, setDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

    const [resizing, setResizing] = useState(false);
    const [resizeStart, setResizeStart] = useState({ x: 0, y: 0, width: 0, height: 0 });

    const [showOverlay, setShowOverlay] = useState(false);
    const titlebarRef = useRef();
    // Bring viewer to front
    const bringToFront = () => {
        zIndexCounter += 1;
        setZIndex(zIndexCounter);
    };

    // Start dragging
    const handleDragMouseDown = (e) => {
        if (e.target !== titlebarRef.current) {
            return;
        }
        e.stopPropagation();
        bringToFront();
        setDragging(true);
        setShowOverlay(true); // show overlay
        setDragOffset({ x: e.clientX - position.x, y: e.clientY - position.y });
    };

    // Start resizing
    const handleResizeMouseDown = (e) => {
        e.stopPropagation();
        bringToFront();
        setResizing(true);
        setShowOverlay(true); // show overlay
        setResizeStart({ x: e.clientX, y: e.clientY, width: size.width, height: size.height });
    };

    // Mouse move and up
    const handleMouseMove = (e) => {
        if (dragging) {
            setPosition({ x: e.clientX - dragOffset.x, y: e.clientY - dragOffset.y });
        } else if (resizing) {
            const newWidth = resizeStart.width + (e.clientX - resizeStart.x);
            const newHeight = resizeStart.height + (e.clientY - resizeStart.y);
            setSize({ width: Math.max(300, newWidth), height: Math.max(200, newHeight) });
        }
    };

    const handleMouseUp = () => {
        setDragging(false);
        setResizing(false);
        setShowOverlay(false);
    };
    const handleClose = (e) => {
        e.stopPropagation();
        close?.();
    }
    if (!url) {
        return null;
    }
    return (
        <>
            <div
                style={{
                    position: 'absolute',
                    left: position.x,
                    top: position.y,
                    width: size.width,
                    height: size.height,
                    borderRadius: 4,
                    backgroundColor: '#fff',
                    boxSizing: 'border-box',
                    userSelect: 'none',
                    border: "1px solid #7b7d80ff",
                    boxShadow: "0px 1px 5px #283da3",
                    zIndex: zIndex,
                }}
                className='document-viewer'
            >
                <div
                    onMouseDown={handleDragMouseDown}
                    ref={titlebarRef}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width:"100%",
                        height: 60,
                        backgroundColor: '#445385',
                        cursor: 'grab',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        color: '#fff',
                        userSelect: 'none',
                        zIndex: 2,
                        borderBottom: "1px solid #7b7d80ff",
                        paddingLeft: "15px",
                        paddingRight: "15px"
                    }}
                >
                    <label>
                        {icon} {title}
                    </label>
                    <FontAwesomeIcon icon={faTimes} size='2x' style={{ cursor: "pointer", position: "absolute", left: 15 }} onClick={handleClose} />
                </div>
                {/* Drag icon */}
                {/* <div
                    onMouseDown={handleDragMouseDown}
                    style={{
                        position: 'absolute',
                        bottom: 4,
                        left: 2,
                        width: 24,
                        height: 24,
                        backgroundColor: '#007bff',
                        borderRadius: 4,
                        cursor: 'grab',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontWeight: 'bold',
                        userSelect: 'none',
                        zIndex: 2,
                        cursor:"default"
                    }}
                    title="Drag"
                >
                    <FontAwesomeIcon icon={faArrowsAlt} size='lg' />
                </div> */}


                <iframe
                    src={url}
                    title="Document Viewer"
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    allowFullScreen
                    className='frame-docviewer'
                    referrerPolicy ="same-origin"
                />

                {/* Resize handle */}
                <div
                    onMouseDown={handleResizeMouseDown}
                    style={{
                        position: 'absolute',
                        width: '16px',
                        height: '16px',
                        right: 0,
                        bottom: 0,
                        cursor: 'se-resize',
                        backgroundColor: '#ccccccff',
                    }}
                />
                <ArrowLeftSquareFill className='hoverIcon btnTooltip' data-tooltip="بازگشت" color='#ff8100'  size={35} style={{position:"absolute", bottom:7, left:15}} onClick={()=>history.goBack()}/>                
            </div>

            {/* Drag overlay */}
            {showOverlay && (
                <div
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        cursor: dragging ? 'grabbing' : resizing ? 'se-resize' : 'default',
                        zIndex: 9999,
                    }}
                />
            )}
        </>
    );
};

export default DocumentViewer;
